export class ProviderUserConfirmRequest {
  protected key: string;

  constructor(key: string) {
    this.key = key;
  }
}
